import { styled } from "styled-components";

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background: var(--background-secondary-color);
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 120px auto;
  justify-content: center;
  transition: var(--transition);
  padding: 0px 2rem;
  padding-top: 30px;
  border-radius: 10px;
  h4,
  h5,
  p {
    text-align: center;
  }
  p {
    color: var(--text-secondary-color);
  }
  .service-img {
    box-shadow: 5px 5px 5px var(--shadow-1);
  }

  &:hover {
    box-shadow: var(--shadow-1);
    background: var(--white);
    cursor: pointer;

    .service-demo-card {
      bottom: 20px;
    }
    .service-icon {
      bottom: 8rem;
    }
    h4,
    p {
      color: var(--black);
    }
  }
`;

export const ServiceContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  overflow: hidden;
`;

export const Image = styled.img`
  width: 100%;
  background-position: center;
  background-size: contain;
`;
